import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CACHE_TTL, requestCache } from './request-cache';
import { environment } from './../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RegionAreaService {

  endpoint = environment.endpoint();
  _urlRegions = '/regions'
  _urlRegionsId = '/regions/:id'
  _urlAreas = '/areas'
  _urlAreasId = '/areas/:id'
  _urlRegionSigns = '/regions?setSignalings=true'
  _urlAreaSigns = '/areas?setSignalings=true'
  private _regionByLatLng = '/regions?lat=latitude&lng=longitude';
  private _areaByLatLng = '/areas?lat=latitude&lng=longitude';

  constructor(private _http: HttpClient) { }

  submitRegion(body) {
    const url = this.endpoint + this._urlRegions
    return this._http.post(url, body)
  }

  editRegion(region, regionId: string) {
    const url = this.endpoint + this._urlRegionsId.replace(':id', regionId)
    return this._http.put(url, region)
  }

  editArea(area, areaId: string) {
    const url = this.endpoint + this._urlAreasId.replace(':id', areaId)
    return this._http.put(url, area)
  }

  getRegions() {
    const url = this.endpoint + this._urlRegions
    return requestCache.get(url, CACHE_TTL.geography, () => this._http.get(url))
  }
  submitArea(body) {
    const url = this.endpoint + this._urlAreas
    return this._http.post(url, body)
  }
  getAreas() {
    const url = this.endpoint + this._urlAreas
    return requestCache.get(url, CACHE_TTL.geography, () => this._http.get(url))
  }

  deleteRegion(id: string) {
    const url = this.endpoint + this._urlRegionsId.replace(':id', id)
    return this._http.delete(url)
  }

  deleteAreas(id: string) {
    const url = this.endpoint + this._urlAreasId.replace(':id', id)
    return this._http.delete(url)
  }

  getRegionSigns() {
    const url = this.endpoint + this._urlRegionSigns
    return this._http.get(url)
  }

  getAreaSigns() {
    const url = this.endpoint + this._urlAreaSigns
    return this._http.get(url)
  }

  getSingleRegion(id: string) {
    const url = this.endpoint + this._urlRegionsId.replace(':id', id)
    return requestCache.get(url, CACHE_TTL.geography, () => this._http.get(url))
  }

  getSingleArea(id: string) {
    const url = this.endpoint + this._urlAreasId.replace(':id', id)
    return requestCache.get(url, CACHE_TTL.geography, () => this._http.get(url))
  }

  getRegionSignalings(id: string) {
    const url = this.endpoint + this._urlRegionsId.replace(':id', id) + '?setSignalings=true'
    return this._http.get(url)
  }

  getAreaSignalings(id: string) {
    const url = this.endpoint + this._urlAreasId.replace(':id', id) + '?setSignalings=true'
    return this._http.get(url)
  }

  // Retorna Regioes pela latLng
  getRegionByLatLng(latLng: any[]) {
    const regionUrl = this._regionByLatLng.replace('latitude', latLng[0]).replace('longitude', latLng[1]);
    const url = this.endpoint + regionUrl;
    // O detalhe e o cadastro pediam a região do mesmo ponto várias vezes seguidas.
    return requestCache.get(url, CACHE_TTL.geography, () => this._http.get(url));
  }

  // Retorna Areas pela latLng
  getAreaByLatLng(latLng: any[]) {
    const areaUrl = this._areaByLatLng.replace('latitude', latLng[0]).replace('longitude', latLng[1]);
    const url = this.endpoint + areaUrl;
    return requestCache.get(url, CACHE_TTL.geography, () => this._http.get(url));
  }
}
